<template>
  <label
    class="base-checkbox"
    :class="[
      `base-checkbox-${variant}`,
      {
        checked: value,
        disabled,
        'icon-right': iconPosition === 'right'
      }
    ]"
  >
    <input
      class="base-checkbox-input"
      type="checkbox"
      :checked="value"
      :disabled="disabled"
      @change="handleChange"
    >
    <span v-if="iconPosition !== 'right'" class="base-checkbox-marker" aria-hidden="true">
      <img v-if="value" class="base-checkbox-icon" :src="checkedIcon" alt="">
    </span>
    <span class="base-checkbox-content">
      <slot></slot>
    </span>
    <span v-if="iconPosition === 'right'" class="base-checkbox-marker" aria-hidden="true">
      <img v-if="value" class="base-checkbox-icon" :src="checkedIcon" alt="">
    </span>
  </label>
</template>

<script>
import checkedIcon from '@/assets/images/icons/duihao.svg'

// 常量：复选图标位置枚举，左侧用于协议，右侧用于功能选项
const CHECKBOX_ICON_POSITIONS = ['left', 'right']

// 常量：复选组件视觉类型，按业务位置复用不同布局
const CHECKBOX_VARIANTS = ['agreement', 'feature']

export default {
  name: 'BaseCheckbox',
  props: {
    // 关键状态：父组件通过 v-model 控制是否选中
    value: {
      type: Boolean,
      default: false
    },
    // 常量参数：控制复选图标展示在文字左侧或右侧
    iconPosition: {
      type: String,
      default: 'left',
      validator(value) {
        return CHECKBOX_ICON_POSITIONS.indexOf(value) > -1
      }
    },
    // 常量参数：控制复选组件在不同业务位置的视觉规则
    variant: {
      type: String,
      default: 'agreement',
      validator(value) {
        return CHECKBOX_VARIANTS.indexOf(value) > -1
      }
    },
    // 逻辑分支：禁用态用于后续扩展，当前登录和试用入口默认可点击
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkedIcon
    }
  },
  methods: {
    // 方法：把原生 checkbox 的变化同步给父组件 v-model
    handleChange(event) {
      this.$emit('input', event.target.checked)
    }
  }
}
</script>

<style scoped lang="less">
.base-checkbox{
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;

  &.disabled{
    cursor: not-allowed;
    opacity: 0.55;
  }
}

.base-checkbox-input{
  position: absolute;
  left: 0;
  top: 0;
  width: 12px;
  height: 12px;
  margin: 0;
  opacity: 0;
  cursor: pointer;

  &:disabled{
    cursor: not-allowed;
  }
}

.base-checkbox-marker{
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border: 1px solid #D9D9D9;
  border-radius: 50%;
  box-sizing: border-box;
  pointer-events: none;
}

.base-checkbox-icon{
  width: 10px;
  height: 10px;
  display: block;
  filter: brightness(0) invert(1);
}

.base-checkbox-content{
  min-width: 0;
  display: flex;
  align-items: center;
}

.base-checkbox.checked{
  .base-checkbox-marker{
    border-color: #2F7BFF;
    background: #2F7BFF;
  }
}

.base-checkbox-agreement{
  margin-top: 4px;
  color: #A6A6A6;
  font-size: 10px;
  line-height: 18px;
  white-space: nowrap;

  .base-checkbox-marker{
    margin-right: 5px;
  }

  /deep/ a{
    color: #2F7BFF;
  }
}

.base-checkbox-feature{
  width: 100%;
  height: 36px;
  margin-bottom: 12px;
  padding: 0 12px;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  background: #fff;
  justify-content: space-between;
  color: #000000D9;
  font-size: 12px;
  line-height: 18px;

  &.checked{
    border-color: #7EB7FF;
    background: #F7FBFF;
  }
}

.base-checkbox-feature.icon-right{
  .base-checkbox-marker{
    margin-left: 12px;
  }
}
</style>
